import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OOCanvas } from 'src/app/shared/models/oo-canvas';
import { OOMenuItem } from 'src/app/shared/models/oo-menu-item';
import { Order } from 'src/app/shared/models/order';
import { AppService } from './app.service';
import { FocuslinkService } from './focuslink.service';
import { OrderSocketService } from './order-socket.service';
import { OOVenueService } from './venue-service';

@Injectable({
	providedIn: 'root',
})
export class OnlineOrderService {
	order: BehaviorSubject<Order> = new BehaviorSubject<Order>(null);
	orderRefreshDateTime: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);
	sessionId: string;

	subscribedCheckKey: string;

	menuItems: BehaviorSubject<OOMenuItem[]> = new BehaviorSubject<OOMenuItem[]>([]);
	canvases: BehaviorSubject<OOCanvas[]> = new BehaviorSubject<OOCanvas[]>([]);

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		private focuslink: FocuslinkService,
		public orderSocketService: OrderSocketService
	) {}

	async storeOrder(order: Order, sessionId: string) {
		return;
		this.order.next(order);
		const orderSubmitResponse = await this.focuslink.onlineOrderSave(this.venueService.venueKey, this.order.value, sessionId);
		this.order.next(orderSubmitResponse);
		!this.subscribedCheckKey && this.subscribeToCheckKey(this.order.value.checkKey);
		return this.order.value;
	}

	async removeItemFromOrder(checkKey: string, itemKey: string) {
		console.log(`Removing item ${itemKey} from check ${checkKey}`);
	}

	async subscribeToCheckKey(checkKey: string) {
		this.orderSocketService.connect(this.venueService.venueKey, checkKey);
		this.subscribedCheckKey = checkKey;
		this.orderSocketService.socketMessage.subscribe((data) => {
			console.log(`checkKeyMessage`);
			if (data.message === 'posCheckSave' && data.payload?.lastSid && data.payload?.lastSid !== this.sessionId) {
				this.order.next(new Order(data.payload));
				this.orderRefreshDateTime.next(new Date());
				console.log(`order updated`);
			}
		});
	}

	async unsubscribeFromCheckKey(checkKey: string) {
		this.orderSocketService.disconnect(this.venueService.venueKey, checkKey);
		this.subscribedCheckKey = null;
	}
}
